module.exports = __webpack_public_path__ + "public/images/reply.58cab54ac6d3a03769d38b82aa6de048.svg";